import * as React from "react";
import { PlayState, Tween } from "react-gsap";
import styled from "styled-components";
import { Controller, Scene } from "react-scrollmagic";
import SampleLinkButton from "./parts/SampleLinkButton";
import { MAX_WIDTH, MAX_WIDTH_STR, WHATISMOIRE_URL } from "../model/Const";
import { OrientationContext } from "../provider/OrientationProvider";
import { IUADevice, userAgentInfo } from "../model/UserAgentInfo";
import { CSSProperties } from "react";

const MessageP = styled.p`
	text-align: center;
`;

export default function Overview() {

	// トリガーとなる要素
	const triggerRef = React.useRef<HTMLDivElement>( null );

	// トリガーとなるID
	const [triggerId, setTriggerId] = React.useState( "" );

	// 初回のみ実行
	React.useEffect( () => {
		setTriggerId( "#overview" );
	}, [] );

	// useContext
	const context = React.useContext( OrientationContext );

	// 最大幅を設定するスタイル（PCの場合のみ設定）
	const maxWidthStyle = React.useMemo( () => {
		// 幅が最大幅より大きく、PCだったら最大幅を指定
		if ( window.innerWidth > MAX_WIDTH && userAgentInfo.device === IUADevice.pc ) {
			return {
				parentDiv: {
					maxWidth: MAX_WIDTH_STR,
					margin: "auto"
				} as CSSProperties,
				fontP: {
					fontSize: "1.5rem"
				} as CSSProperties
			}
		}

		return {
			parentDiv: undefined,
			fontP: {
				fontSize: "2.5vw"
			} as CSSProperties
		};
	}, [context.resize] );

	return (
		<>
			<div id="overview" ref={triggerRef}/>
			<Controller>
				{/*概要*/}
				<Scene
					duration={100}
					reverse={true}
					triggerElement={triggerId}
					triggerHook={0.7}
				>
					{(
						progress: number,
						event: any
					) => (
						<div
							style={{
								width: "100vw",
								position: "relative",
								textAlign: "center",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								flexDirection: "column",
								backgroundColor: "white"
							}}
							className={"mincho"}
						>
							<div style={{
								...maxWidthStyle.parentDiv,
								position: "relative",
								width: "100%",
							}}>

								<Tween
									paused
									wrapper={<div style={{ position: "relative" }}/>}
									from={{
										css: {
											opacity: 0,
											rotationX: -90,
											transformOrigin: '50% top -100'
										},
										ease: 'Strong.easeOut',
									}}
									to={{
										css: {
											opacity: 1,
											rotationX: 0
										},
										ease: 'Strong.easeOut',
									}}
									stagger={0.2}
									duration={1}
									playState={
										(event.type === "enter" && event.scrollDirection === "FORWARD") ? PlayState.play :
											(event.type === "enter" && event.scrollDirection === "REVERSE") ? PlayState.reverse : undefined
									}
								>
									<MessageP style={{ ...maxWidthStyle.fontP }}>まんがにこだわる共同印刷ならではの、</MessageP>
									<MessageP style={{ ...maxWidthStyle.fontP }}>高品質な電子コミック制作ソリューションが</MessageP>
									<MessageP
										style={{ ...maxWidthStyle.fontP }}>『eComicシリーズ』です。</MessageP>
									<MessageP
										style={{ ...maxWidthStyle.fontP }}>モアレを抑制しつつ高品質のまんが画像を生成する『eComicScreen+™️』</MessageP>
									<MessageP
										style={{ ...maxWidthStyle.fontP }}>過去に制作したまんが画像を超解像技術でデジタルリマスターする『eComicSR®️️』</MessageP>
									<MessageP
										style={{ ...maxWidthStyle.fontP }}>2つの技術でこれまでの電子コミックの常識を変えます。</MessageP>
								</Tween>
							</div>
						</div>
					)}
				</Scene>
			</Controller>

			<SampleLinkButton
				toURL={WHATISMOIRE_URL}
				text={"モアレとは"}
			/>
		</>
	);
};